
import moment_tz from "moment-timezone";
import moment from "moment-timezone";
import { store } from 'state-management/store'
import { useDispatch } from 'react-redux'
import { changeCompetition } from 'state-management/actions'
import { useEffect } from "react";
import Label from "components/general/Label";
import 'moment/locale/de'
import 'moment/locale/fr'
import 'moment/locale/es'
import 'moment/locale/pl'

export const ALL_URL = {
  "ALL_DISC": "all-disc",
  "ALL_EVENT": "all-event",
  "ALL_DAYS": "all-days",
  "ALL_MEDAL": "all-medal",
  "ALL_NOC": "all-noc",
  "ALL_PDFs": "all-reports"

};

export function dateFormat(_date, _timeZone, _format) {
  moment.locale(store.getState().appGlobal.locale);
  _timeZone = (_timeZone === "" || _timeZone === undefined) ? store.getState().appGlobal.timezone : _timeZone;
  _format = (_format === "" || _format === undefined) ? "YYYY-MM-DD" : _format;
  return moment_tz
    .utc(new Date(_date))
    .tz(_timeZone)
    .format(_format);
}

export function dateToday(_timeZone, _format) {
  return dateFormat(Date.now(), _timeZone, _format)
}

export function groupByDate(array, key, _timeZone) {
  _timeZone = (_timeZone === "" || _timeZone === undefined) ? store.getState().appGlobal.timezone : _timeZone;
  const res = array.reduce((a, c) => (a[dateFormat(c[key], _timeZone)] = (a[dateFormat(c[key], _timeZone)] || []).concat(c), a), {})
  return res;
}

export function isValidDate(date) {
  return moment(date, "YYYY-MM-DD", true).isValid();
}


export function CompetitionToStore(competition) {
  //Store championship in Store
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(changeCompetition(competition));
  }, [])
}

export function CompetitionFromStore() {
  return store.getState().appGlobal.competition
}

export function RscFromStore() {
  return store.getState().appGlobal.rsc
}

function getKeyByValue(object, keyName, value) {
  return Object.keys(object).find(key => object[keyName] === value);
}






/**
 * Return String URL composed 
 *
 * @paramsURL :  get an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 * @path : path URL
 * 
 * Structure: language/path/discipline/date/rsc 
 */
export function getURL(paramsURL, path) {

  let competition = (paramsURL.mirs_competition !== undefined) ? `/${paramsURL.mirs_competition}` : `/${process.env.REACT_APP_DEFAULT_COMPETITION}`;
  let language = (paramsURL.mirs_language !== undefined) ? `/${paramsURL.mirs_language}/` : `/${process.env.REACT_APP_DEFAULT_LANGUAGE}/`;
  let discipline = (paramsURL.mirs_discipline !== undefined) ? `/${paramsURL.mirs_discipline}` : '';
  let date = (paramsURL.mirs_date !== undefined && paramsURL.mirs_date !== '') ? `/${paramsURL.mirs_date}` : '';
  let event = (paramsURL.mirs_event !== undefined && paramsURL.mirs_event !== "") ? `/${paramsURL.mirs_event}` : '';
  let rsc = (paramsURL.mirs_rsc !== undefined && paramsURL.mirs_rsc !== '') ? `/${paramsURL.mirs_rsc}` : '';
  let code = (paramsURL.mirs_code !== undefined && paramsURL.mirs_code !== '') ? `/${paramsURL.mirs_code}` : '';
  let noc = (paramsURL.mirs_noc !== undefined && paramsURL.mirs_noc !== '') ? `/${paramsURL.mirs_noc}` : '';
  let medal = (paramsURL.mirs_medal !== undefined && paramsURL.mirs_medal !== '') ? `/${paramsURL.mirs_medal}` : '';
  let gender = (paramsURL.mirs_gender !== undefined && paramsURL.mirs_gender !== "") ? `/${paramsURL.mirs_gender}` : '';
  let brokenRecords = (paramsURL.mirs_brokenRecords !== undefined && paramsURL.mirs_brokenRecords !== '') ? `/${paramsURL.mirs_brokenRecords}` : '';
  let pdftype = (paramsURL.mirs_pdftype !== undefined && paramsURL.mirs_pdftype !== "") ? `/${paramsURL.mirs_pdftype}` : '';

  let url = ""

  if (path === 'disciplines') {
    url = competition + language + path
  }

  if (path === 'competitionschedule') {
    url = competition + language + path
  }

  if (path === 'records') {
    url = competition + language + path
    if (discipline) {
      url += discipline
      if (event)
        url += event
    }
    if (noc) {
      url = competition + language + path;
      (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
      (event) ? url += event : url += "/" + ALL_URL.ALL_EVENT;
      url += noc
    }
    if (brokenRecords) {
      url = competition + language + path;
      (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
      (event) ? url += event : url += "/" + ALL_URL.ALL_EVENT;
      (noc) ? url += noc : url += "/" + ALL_URL.ALL_NOC;
      url += brokenRecords
    }
  }

  if (path === 'schedule') {
    //url = competition + language + path + discipline + date + event
    url = competition + language + path;
    (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
    (date) ? url += date : url += "/" + ALL_URL.ALL_DAYS;
    (event) ? url += event : url += "/" + ALL_URL.ALL_EVENT;
  }

  if (path === 'schedulebynoc') {
    url = competition + language + path + noc
  }

  if (path === 'medallists') {
    url = competition + language + path
    if (discipline) {
      url += discipline
      if (event)
        url += event
    }
    if (noc) {
      url = competition + language + path;
      (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
      (event) ? url += event : url += "/" + ALL_URL.ALL_EVENT;
      url += noc
    }
    if (medal) {
      url = competition + language + path;
      (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
      (event) ? url += event : url += "/" + ALL_URL.ALL_EVENT;
      (noc) ? url += noc : url += "/" + ALL_URL.ALL_NOC;
      url += medal
    }
    if (date) {
      url = competition + language + path;
      (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
      (event) ? url += event : url += "/" + ALL_URL.ALL_EVENT;
      (noc) ? url += noc : url += "/" + ALL_URL.ALL_NOC;
      (medal) ? url += medal : url += "/" + ALL_URL.ALL_MEDAL;
      url += date
    }
  }

  if (path === 'athletes') {
    url = competition + language + path;
    (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
    (noc) ? url += noc : url += "/" + ALL_URL.ALL_NOC;
  }

  if (path === 'teams') {
    url = competition + language + path;
    (discipline) ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
    (noc) ? url += noc : url += "/" + ALL_URL.ALL_NOC;
    (event) ? url += event : url += "/" + ALL_URL.ALL_EVENT;
  }

  if (path === 'reports') {
    url = competition + language + path
    if (discipline) {
      url += discipline
      if (event)
        url += event
    }
    if (pdftype) {
      if (!event) { url += "/" + ALL_URL.ALL_EVENT };
      url += pdftype
    }


  }

  if (path === 'medal' || path === 'multimedallists') {
    url = competition + language + path;
    (discipline !== '') ? url += discipline : url += "/" + ALL_URL.ALL_DISC;
    (noc) ? url += noc : url += "/" + ALL_URL.ALL_NOC;
    if (gender) {
      url += gender
    }

  }


  if (path === 'results'
    || path === 'pool'
    || path === 'bracket'
    || path === 'ranking'
  ) {

    url = competition + language + path + discipline + rsc
  }

  if (path === 'bios') {
    url = competition + language + path + code
  }

  if (path === 'liveIndividual'
    || path === 'liveTeam'
    || path === 'placings'
    || path === 'competitionstatus'
    || path === 'hearingschedule'
  ) {
    url = competition + language + path + discipline
  }


  if (path === 'todayMatches') {
    let _date = date.includes('Day') ? '/today' : date
    url = competition + language + path + discipline + _date
  }

  if (path === 'todayAthMatches') {
    let _date = date.includes('Day') ? '/today' : date
    url = competition + language + path + discipline + _date
  }

  if (path === 'todayTeamMatches') {
    let _date = date.includes('Day') ? '/today' : date
    url = competition + language + path + discipline + _date
  }

  if (path === 'noclist') {
    url = competition + language + path
  }
  return (url)
}


export const getAge = (dateString) => {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export const getHeight = (heightInCms) => {
  const realFeet = ((heightInCms * 0.393700) / 12);
  const feet = Math.floor(realFeet);
  const inches = Math.round((realFeet - feet) * 12);
  const meters = heightInCms / 100;
  return `${meters}/${feet}'${inches}''`;
}

// ignores case-sensitive
const getValueUppercase = value => (typeof value === 'string' ? value.toUpperCase() : value);

/**
 * Filters an array of objects (one level-depth) with multiple criteria.
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */
export function findArray(array, filters) {
  if (array === undefined) {
    return ''
  }

  if (array && Array.isArray(array)) {
    const filterKeys = Object.keys(filters);
    const element = array.find(item => {
      // validates all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        if (!filters[key].length) return true;
        return filters[key].find(filter => getValueUppercase(filter) === getValueUppercase(item[key]));
      });
    });
    return typeof element === "object" ? element : '';
  } else {
    return ''
  }
}

export function findParticResult(array, code) {
  if (!code) return '';
  return array?.find(item => item?.participant ? item?.participant?.code === code : '');
}

/**
 * Filters an array of objects (one level-depth) with multiple criteria.
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */
export function filterArray(array, filters) {
  if (array === undefined) {
    return ''
  }
  const filterKeys = Object.keys(filters);
  const element = array.filter(item => {
    // validates all filter criteria
    return filterKeys.every(key => {
      // ignores an empty filter
      if (!filters[key].length) return true;
      return filters[key].find(filter => getValueUppercase(filter) === getValueUppercase(item[key]));
    });
  });
  return typeof element === "object" ? element : '';

}

export function findObject(arr, item, val) {
  const element = arr.find((value) => {
    return value[item] === val;
  });
  return typeof element === "object" ? element : '';
}

export function findObject2(arr, item, val, item2, val2) {
  const element = arr.find((value) => {
    return value[item] === val && value[item2] === val2;
  });
  return typeof element === "object" ? element : '';
}

export function arraysEqual(a1, a2) {
  /* WARNING: arrays must not contain {objects} or behavior may be undefined */
  return JSON.stringify(a1) === JSON.stringify(a2);
}

export function capitalizeFirstLetter(string) {
  return string === undefined ? '' : string.charAt(0).toUpperCase() + string.slice(1)
}

export function capitalize(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
}

export function isParalympic(_competition) {
  return (_competition === "PG2024");
}


export const sortDataByFieldDesc = (array, field, asc = true, dateType = false) => {

  if (Array.isArray(array)) {
    if (dateType) {
      if (asc) {
        array.sort((a, b) => (new Date(a[field]) > new Date(b[field])) ? 1 : -1);
      } else {
        array.sort((a, b) => (new Date(b[field]) > new Date(a[field])) ? 1 : -1);
      }
    } else {
      if (asc) {
        array.sort((a, b) => (a[field] > b[field]) ? 1 : -1)
      } else {
        array.sort((a, b) => (b[field] > a[field]) ? 1 : -1)
      }
    }
  }
  return array





};